// extracted by mini-css-extract-plugin
module.exports = {"Ribbon":"Ribbon_Ribbon__5lQnn","RibbonHot":"Ribbon_RibbonHot__2lSml","RibbonSale":"Ribbon_RibbonSale__XH9tm"};